import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { REFRESH_TOKEN, TOKEN } from '@shared/constants/common.constants';
import { CookieHandlerService } from '@features/sign-in/services/cookie.service';
import { LOGIN } from '@shared/constants/routing-paths.constants';
import { Apollo } from 'apollo-angular';
import { APP_CONFIG } from '@shared/tokens/global';
import { IS_EMBED_LINK } from '@shared/constants/is-embed-link.constant';
import { KEY_UPLOADING_FILES_IN_LOCAL_STORAGE } from '@shared/components/uploader/constants/uploader.constant';
import { Logger } from '@3dsource/utils';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apollo = inject(Apollo);
  private router = inject(Router);
  private cookieService = inject(CookieHandlerService);
  private tokenPrefix = inject(APP_CONFIG).tokenPrefix;

  setAccessToken(token: string) {
    this.cookieService.set(TOKEN(this.tokenPrefix), token);
  }

  setRefreshToken(token: string) {
    this.cookieService.set(REFRESH_TOKEN(this.tokenPrefix), token);
  }

  get isLoggedIn() {
    return (
      !!this.getToken(TOKEN(this.tokenPrefix)) ||
      !!this.getToken(REFRESH_TOKEN(this.tokenPrefix))
    );
  }

  logout(reason?: string) {
    if (reason) {
      Logger.warn(reason);
    }
    if (IS_EMBED_LINK) {
      return;
    }

    if (this.isLoggedIn) {
      this.clearStorage();

      void this.apollo.client.clearStore();
      void this.apollo.client.cache.reset();

      void this.apollo.use('legacy').client.clearStore();
      void this.apollo.use('legacy').client.cache.reset();

      void this.apollo.use('ecom').client.clearStore();
      void this.apollo.use('ecom').client.cache.reset();
    }

    void this.router.navigate([LOGIN], {
      replaceUrl: true,
    });
  }

  getToken(tokenKey: string) {
    return this.cookieService.get(tokenKey);
  }

  clearStorage() {
    this.cookieService.delete(TOKEN(this.tokenPrefix));
    this.cookieService.delete(REFRESH_TOKEN(this.tokenPrefix));

    localStorage.removeItem('user');
    localStorage.removeItem(KEY_UPLOADING_FILES_IN_LOCAL_STORAGE);
  }
}
